import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {signature ,thirdAuth ,authcodereport ,switchOper ,msgTemplateCheck} = api

/**
 * 查找
 */
export async function findSignature(params) {
    return request({url: signature, method: 'post', data: params,})
}
export async function findThirdAuth(params) {
    return request({url: thirdAuth, method: 'get', data: params,})
}
export async function findMsgTemplateCheck(params) {
    return request({url: msgTemplateCheck, method: 'get', data: params,})
}

/**
 * 授权上报
 */
 export async function updateAuthcodereport(params) {
    return request({url: authcodereport+`?hostUserId=${params.hostUserId}&authCode=${params.auth_code}&expiresIn=${params.expires_in}`, method: 'post', data: params,})
}
/**
 * 推送开关
 */
 export async function updateSwitchOpert(params) {
    return request({url: switchOper+`?hostUserId=${params.hostUserId}&openState=${params.openState}&switchType=${params.switchType}`, method: 'post', data: params,})
}



// WEBPACK FOOTER //
// ./src/services/signature.js